import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useMemo, useState } from "react";
import { getCities } from "@/pages/price-offer/price-offer-helper";
import { useTranslation } from "@i18n";
import { useSellCarData } from "@/common/Contexts/SellCarDataContext";
import { useLang } from "@/common/Contexts/LanguageContext";
import { twMerge } from "tailwind-merge";
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { CDN_LINK } from "@globalConfig";
import { useScreenNavigation } from "@/common/Contexts/ScreenNavigationContext";
import { SELL_CAR_SCREENS } from "@/pages/sell-my-car/constants/screens";
import useHelpers from "@hooks/useHelpers";
import useBoolean from "@hooks/useBoolean";
import { useSearchParams } from "react-router-dom";
import CancelConfirmation from "@/pages/sell-my-car/components/CancelConfirmation";
import { URL_SELL_TRADE_LANDING_v2 } from "@/pages/sell-trade-v2/sell-trade/constants";
import { trackEvents } from "@/common/events/events";
import { getPlatformInfo, toSnakeCase } from "@/utils/GlobalJavascriptFunction";
var CarLocationNotApprovedForInspectionScreen = function CarLocationNotApprovedForInspectionScreen() {
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useSellCarData = useSellCarData(),
    state = _useSellCarData.state,
    dataActions = _useSellCarData.actions;
  var _useScreenNavigation = useScreenNavigation(),
    actions = _useScreenNavigation.actions,
    navState = _useScreenNavigation.state;
  var _useHelpers = useHelpers(),
    navigateToHard = _useHelpers.navigateToHard;
  var lang = useLang();
  var cancelModal = useBoolean();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var requestId = searchParams.get('request_id');
  var cities = useMemo(function () {
    return getCities();
  }, []);
  var _useState = useState(null),
    selected = _useState[0],
    setSelected = _useState[1];
  var cityName = useMemo(function () {
    var _state$selection, _state$selection2, _state$selection2$sel, _state$selection3, _state$selection3$sel;
    if (!(state !== null && state !== void 0 && (_state$selection = state.selection) !== null && _state$selection !== void 0 && _state$selection.selectedCityForInspection)) {
      return "";
    }
    return lang == 'ar' ? state === null || state === void 0 ? void 0 : (_state$selection2 = state.selection) === null || _state$selection2 === void 0 ? void 0 : (_state$selection2$sel = _state$selection2.selectedCityForInspection) === null || _state$selection2$sel === void 0 ? void 0 : _state$selection2$sel.name_ar : state === null || state === void 0 ? void 0 : (_state$selection3 = state.selection) === null || _state$selection3 === void 0 ? void 0 : (_state$selection3$sel = _state$selection3.selectedCityForInspection) === null || _state$selection3$sel === void 0 ? void 0 : _state$selection3$sel.name_en;
  }, [lang]);
  var handleContinue = function handleContinue() {
    // If user selected a new approved city, update the selection
    if (selected) {
      var _state$selection$make, _state$selection$mode, _state$selection$exte, _state$selection$year, _state$selection$odom;
      trackEvents("sell_car_cities_far", {
        car_make: ((_state$selection$make = state.selection.make) === null || _state$selection$make === void 0 ? void 0 : _state$selection$make.name) || "",
        car_model: ((_state$selection$mode = state.selection.model) === null || _state$selection$mode === void 0 ? void 0 : _state$selection$mode.name) || "",
        car_trim: ((_state$selection$exte = state.selection.extension) === null || _state$selection$exte === void 0 ? void 0 : _state$selection$exte.name) || "",
        car_year: ((_state$selection$year = state.selection.year) === null || _state$selection$year === void 0 ? void 0 : _state$selection$year.toString()) || "",
        car_odometer_range: ((_state$selection$odom = state.selection.odometerRange) === null || _state$selection$odom === void 0 ? void 0 : _state$selection$odom.range_ar) || "",
        ownership_type: state.selection.ownership ? toSnakeCase(state.selection.ownership) : "",
        car_city: cityName || "",
        inspection_city: selected === null || selected === void 0 ? void 0 : selected.name_ar,
        platform: getPlatformInfo(),
        version: "3"
      });
      dataActions.setCityForInspection(selected);
    }
    // Navigate back to contact info screen
    actions.navigateToScreen(SELL_CAR_SCREENS.CONTACT_INFO);
  };
  var handleCancelClick = function handleCancelClick() {
    if (requestId) {
      trackEvents("sell_car_request_cancel", {
        request_id: requestId,
        cancel_stage: "city_not_available",
        platform: getPlatformInfo(),
        cancellation_reason: "null"
      });
      navigateToHard(URL_SELL_TRADE_LANDING_v2);
      return;
    }
    cancelModal.setTrue();
  };
  var handleCancelConfirm = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            cancelModal.setFalse();
            navigateToHard(URL_SELL_TRADE_LANDING_v2);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCancelConfirm() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleCancelDismiss = function handleCancelDismiss() {
    cancelModal.setFalse();
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Layout, {
    hasMobFooter: false,
    hideDownloadBanner: true
  }, /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-not-approved-screen",
    className: "flex flex-col p-4 items-between md:max-w-[560px] md:mx-auto md:border md:border-solid md:border-gray-echo md:mt-[70px] rounded-2xl md:p-6"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-8"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4 items-center"
  }, /*#__PURE__*/React.createElement("img", {
    id: "sell-car-location-not-approved-icon",
    src: CDN_LINK + "/assets/images/location.svg",
    alt: "",
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-4"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "sell-car-location-not-approved-title",
    className: "text-xl font-bold text-primary-new leading-6 text-center"
  }, tShort("sell_trade_v2/location_not_approved_title", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("p", {
    id: "sell-car-location-not-approved-description",
    className: "text-base text-black-primary leading-6 text-center"
  }, tShort("sell_trade_v2/location_not_approved_description", {
    ns: "web_sell_trade"
  }).replace("{city_name}", cityName)))), /*#__PURE__*/React.createElement("div", {
    id: "sell-car-location-not-approved-cities",
    className: "flex flex-col gap-4"
  }, cities === null || cities === void 0 ? void 0 : cities.map(function (city, index) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
      type: "button",
      id: "sell-car-location-not-approved-city-".concat(index),
      onClick: function onClick() {
        return setSelected(city);
      },
      className: twMerge("w-full p-3 text-start rounded-lg transition-colors text-gray-text text-sm border border-gray-echo border-solid bg-white cursor-pointer flex items-center", (selected === null || selected === void 0 ? void 0 : selected.id) == (city === null || city === void 0 ? void 0 : city.id) && "bg-blue-50 border border-primary font-medium")
    }, /*#__PURE__*/React.createElement(Conditional, {
      condition: lang == 'ar'
    }, /*#__PURE__*/React.createElement(Then, null, city === null || city === void 0 ? void 0 : city.name_ar), /*#__PURE__*/React.createElement(Else, null, city === null || city === void 0 ? void 0 : city.name_en))));
  }))), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col gap-2 mt-[60px]"
  }, /*#__PURE__*/React.createElement("button", {
    id: "sell-car-location-not-approved-continue-btn",
    className: "w-full cursor-pointer border-none bg-primary-new text-white p-3 rounded-lg outline-none text-base font-semibold md:max-w-[330px] md:mx-auto disabled:bg-gray-echo disabled:text-[#979797] disabled:pointer-events-none disabled:cursor-not-allowed",
    onClick: handleContinue,
    disabled: !selected
  }, tShort("sell_trade_v2/continue_order", {
    ns: "web_sell_trade"
  })), /*#__PURE__*/React.createElement("button", {
    id: "sell-car-location-not-approved-cancel-btn",
    className: "w-full border border-solid border-primary-new rounded text-center text-primary-new text-base px-4 py-3 font-semibold cursor-pointer md:max-w-[330px] md:mx-auto bg-white",
    onClick: handleCancelClick
  }, tShort("sell_trade_v2/cancel_order", {
    ns: "web_sell_trade"
  })))), /*#__PURE__*/React.createElement(CancelConfirmation, {
    isOpen: cancelModal.value,
    onClose: handleCancelDismiss,
    haveClose: true,
    title: tShort("sell_trade_v2/order_confirm_title", {
      ns: "web_sell_trade"
    }),
    icon: CDN_LINK + "/assets/images/exclamation-mark.svg",
    description: tShort("sell_trade_v2/order_confirm_description", {
      ns: "web_sell_trade"
    }),
    confirmButton: {
      text: tShort("sell_trade_v2/confirm_order_button_text", {
        ns: "web_sell_trade"
      }),
      variant: "primary",
      action: handleCancelDismiss
    },
    cancelButton: {
      text: tShort("sell_trade_v2/cancel_order_button_text", {
        ns: "web_sell_trade"
      }),
      variant: "outline",
      action: handleCancelConfirm
    }
  })));
};
export default CarLocationNotApprovedForInspectionScreen;